import { useLocation, Route, Routes } from "react-router-dom";
import {ApplicationSelector} from "../pages/ApplicationSelector"
export const AppRoute = () => {
  return (
    <Routes>
      <Route path={`*`} element={<ApplicationSelector/>} /> 
    </Routes>
  );
};
